import "./Paperformat.scss";
import DownloadFormBtn from '../../../../components/Download Form Button/DownloadFormBtn';


const Paperformat = () => {

    const downloadFormButtons = [
        { name: "Paper Format-Arts", file: "/Arts.pdf" },
        { name: "Paper Format-Science", file: "/Science.pdf" },
        { name: "Paper Format-Commerce", file: "/Commerce.pdf" }
      ];

    return (
        
        <section className="paperFormatMainContainer">
  {downloadFormButtons.map((button, index) => (
    <DownloadFormBtn
      key={index}
      btnName={button.name}
      file={button.file}
      titleFontSize="clamp(1rem, 1.3vw, 1.2rem)"
    />
  ))}
  <p style={{fontFamily:"Gilroy-Medium",fontSize:"clamp(1rem, 1.3vw, 1.2rem)"}}>
  Submit papers to 
  <a href="mailto:njsch@nicollege.com" style={{marginLeft:"5px",marginRight:"5px",textDecoration:"none"}}>njsch@nicollege.com</a> 
  in the format prescribed.
</p>
</section>
    )
}

export default Paperformat
